import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { TextArea, TextAreaProps } from '@sato/components';

export const HookFormTextArea = (props: { name: string } & TextAreaProps) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={props.name}
      control={control}
      render={({ field, fieldState }) => (
        <TextArea {...props} {...field} error={fieldState.error?.message} />
      )}
    />
  );
};
